import { service } from '@/ajax/request'
import { AddRecharge, ChargeList } from '@/types/api/recharge'

import { AxiosPromise } from 'axios'


/**
 * 获取充值记录列表
 * @param params 
 */
export const rechargeList = (params: ChargeList): AxiosPromise => (
  service({
    url: `/member/charge/list`,
    method: 'get',
    type: 'form',
    params
  })
)

/**
 * 添加系统充值套餐
 * @param params 
 */
export const createRecharge = (params: AddRecharge): AxiosPromise => (
  service({
    url: `/sysChargePackage/create`,
    method: 'post',
    params
  })
)

/**
 * 逻辑删除ID系统充值套餐
 * @param params 
 */
export const deleteRecharge = (params: { id: number }): AxiosPromise => (
  service({
    url: `/sysChargePackage/delete/${params.id}`,
    method: 'post'
  })
)

/**
 * 查询所有的充值方案
 * @param params 
 */
export const selectAllListRecharge = (params: AddRecharge): AxiosPromise => (
  service({
    url: `/sysChargePackage/selectAllList`,
    method: 'get',
    params
  })
)

/**
 * 修改系统充值套餐
 * @param params 
 */
export const updateRecharge = (params: AddRecharge): AxiosPromise => (
  service({
    url: `/sysChargePackage/update/${params.id}`,
    method: 'post',
    params
  })
)

/**
 * 会员充值统计
 */
export const summaryReport = (): AxiosPromise => (
  service({
    url: `/member/summary/report`,
    method: 'get',
    type: 'form'
  })
)

export const chargeDataBoard = (type:number): AxiosPromise => (
    service({
        url: `/member/charge/dataBoard/${type}`,
        method: 'get',
        type: 'form'
    })
)
